import { useTranslationContext } from "./use-translation-context"
import { TranslationIndicator } from "./translation-indicator"

export function ScheduleTranslationBadge() {
    const { isTranslated, translationMeta, loading, error } = useTranslationContext()

    if (!isTranslated && !loading && !error) return null

    return <TranslationIndicator translationMeta={translationMeta} loading={loading} error={error} />
}
